import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=deb5572e&scoped=true&"
import script from "./PopupWindow.vue?vue&type=script&lang=js&"
export * from "./PopupWindow.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindow.vue?vue&type=style&index=0&id=deb5572e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb5572e",
  null
  
)

export default component.exports